import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVICE_TAG_TYPES } from "./Constants";
import { getAccessToken } from "./Functions";

const baseUrl = `${import.meta.env.VITE_DOCUMENT_API_BASE_URL}`;

export const documentBaseAPI = createApi({
  reducerPath: "documentReducer",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: async (headers) => {
      const token = await getAccessToken();

      headers.set("Accept-Language", "en-US");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("Strict-Transport-Security", "max-age=3600 ; includeSubDomains");
      headers.set("Ocp-Apim-Subscription-Key", import.meta.env.VITE_SUBSCRIPTION_KEY ?? "");

      headers.set("Accept", "*/*");
      headers.set("Accept-Encoding", "gzip, deflate, br");
      headers.set("Connection", "keep-alive");
      return headers;
    },
  }),
  tagTypes: Object.values(SERVICE_TAG_TYPES),
  endpoints: () => ({}),
  keepUnusedDataFor: 1,
});
